import CommonLandingContainer from '../../../../landingComponents/containers/common';
import styles from './founders.module.scss';
import {
  Heading4,
  SecondaryText,
} from '../../../../landingComponents/typography';
import Karuzin from 'src/assets/img/landing/Kostya.png';
import Navoenko from 'src/assets/img/landing/Yura.png';
import InfoPanel from '../../../../landingComponents/containers/infoPanel';
import AnimatedBox from 'src/components/landingComponents/containers/animatedScroll';
import { getClassName } from 'src/Core/utility/jsx';

const Founders = () => {
  return (
    <CommonLandingContainer className={styles.container}>
      <Left />
      <Right />
    </CommonLandingContainer>
  );
};

export default Founders;

const Left = () => {
  return (
    <AnimatedBox className={getClassName([styles.panel])}>
      <div className={styles.foundersTitle}>основатели</div>
      <div className={styles.background}></div>
      <InfoPanel
        className={styles.infoTextPanel}
        Header={() => <Heading4 accent>Константин Карузин</Heading4>}
      >
        <SecondaryText extraSmall>
          Врач-исследователь, 50 научных работ, co-founder и ex-MD bioniq
        </SecondaryText>
      </InfoPanel>
      <div className={getClassName([styles.imageContainer, styles.karuzin])}>
        <img
          fetchpriority="low"
          className={getClassName([styles.image])}
          src={Karuzin}
          alt="Константин Карузин"
        />
      </div>
      {/* </div> */}
    </AnimatedBox>
  );
};

const Right = () => {
  return (
    <AnimatedBox className={getClassName([styles.panel])}>
      <div className={styles.background}></div>
      <InfoPanel
        className={styles.infoTextPanel}
        Header={() => <Heading4 accent>Юрий Навоенко</Heading4>}
      >
        <SecondaryText extraSmall>
          Энтузиаст eco и health tech, ex-CEO Ecoplatform, ex-COO Nedvex
          Consulting 
        </SecondaryText>
      </InfoPanel>
      <div className={getClassName([styles.imageContainer, styles.navoenko])}>
        <img
          fetchpriority="low"
          className={getClassName([styles.image])}
          src={Navoenko}
          alt="Юрий Навоенко"
        />
      </div>
      {/* </div> */}
    </AnimatedBox>
  );
};
